// Abas da tela de uma automação. Fica fora da tela porque a rota valida o
// ?aba= e a tela é carregada sob demanda — importar dela puxaria a tela
// inteira para o bundle principal.
export const AUTOMATION_DETAIL_TABS = ["history", "settings", "body"] as const;
export type AutomationDetailTab = (typeof AUTOMATION_DETAIL_TABS)[number];
